import React from 'react';
import './Contact.css';
import { Helmet } from 'react-helmet-async';

function Contact() {
  return (
    <div className="contact-section">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AutoDealer",
          "name": "FLIP MY CAR",
          "image": "https://flipmycar.fr/logo2.png",
          "description": "Achat, vente, reprise et recherche personnalisée de véhicules d'occasion",
          "address": { "@type": "PostalAddress", "streetAddress": "11 rue de Joyenval", "addressLocality": "Chambourcy", "postalCode": "78240", "addressCountry": "FR" },
          "telephone": "+33682754629",
          "email": "contact@flipmycar.fr",
          "url": "https://flipmycar.fr",
          "openingHoursSpecification": { "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"], "opens": "09:30", "closes": "19:30" }
        })}</script>
      </Helmet>
      <div className="contact-container">
        <div className="contact-info">
          <h2 className="contact-title">
            FLIP MY CAR<br />
            <span className="highlight-green">À VOTRE SERVICE</span>
          </h2>
          
          <div className="contact-details">
            <div className="contact-item">
              <div className="contact-icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div className="contact-text">
                <span className="contact-label">NOTRE ADRESSE</span>
                <p>11 rue de Joyenval, Chambourcy 78240</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <div className="contact-text">
                <span className="contact-label">TÉLÉPHONE</span>
                <p><a href="tel:+33682754629">06 82 75 46 29</a></p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div className="contact-text">
                <span className="contact-label">EMAIL</span>
                <p><a href="mailto:contact@flipmycar.fr">contact@flipmycar.fr</a></p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon-box">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#50BF8F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </div>
              <div className="contact-text">
                <span className="contact-label">HORAIRES</span>
                <p>Du lundi au samedi : 9h30 - 19h30</p>
              </div>
            </div>
          </div>

          <div className="contact-socials">
            <a href="https://www.instagram.com/flipmycar.fr/" target="_blank" rel="noopener noreferrer" className="social-btn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
            </a>
          </div>
        </div>

        <div className="contact-map">
          <iframe 
            src="https://maps.google.com/maps?q=11%20rue%20de%20Joyenval%2C%20Chambourcy%2078240&t=&z=13&ie=UTF8&iwloc=&output=embed" 
            width="100%" 
            height="100%" 
            style={{border:0}} 
            allowFullScreen="" 
            loading="lazy"
            title="Map"
          ></iframe>
        </div>
      </div>

      <div className="contact-cta">
        <h2>PRÊT À CHANGER <span className="highlight-green">DE VÉHICULE ?</span></h2>
        <p>Contactez-nous dès aujourd'hui pour une estimation gratuite ou pour trouver la perle rare.</p>
        <a href="tel:+33682754629" className="cta-button">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          Appeler maintenant
        </a>
      </div>
    </div>
  );
}

export default Contact;
